module.exports = __webpack_public_path__ + "media/images/servico-textil-en-5d43a3af555c9d137b3840d68ceda191.jpg";